import { Theme, styled } from '@nexelem/deprecated-theme';
import { StyledProps } from './StyledTextField';

export function getLabelStyles(typedTheme: Theme, textColor: string, isJumbo = false) {
  return {
    ...(isJumbo ? typedTheme.typography.titilliumWebSemiBold20 : typedTheme.typography.titilliumWebSemiBold14),
    paddingLeft: typedTheme.spacing(2),
    paddingBottom: typedTheme.spacing(2),
    color: textColor,
  };
}

export const StyledInternalGrid = styled('div', {
  shouldForwardProp: (propName: PropertyKey): propName is PropertyKey =>
    !['error', 'isJumbo'].includes(propName as string),
})<StyledProps>(({ theme, error, isJumbo }) => {
  const typedTheme = theme as Theme;
  const { getColor } = typedTheme.palette;
  const { defaultColors } = typedTheme.client.inputs;
  const labelTextColor = error ? defaultColors.error.inputColor : defaultColors.defaultState.labelColor;
  const labelStyles = getLabelStyles(typedTheme, getColor(labelTextColor), isJumbo);

  return {
    label: labelStyles,
    '.helper-text': {
      ...labelStyles,
      width: '100%',
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },
    '.helper-text-icon': {
      ...labelStyles,
      fontSize: typedTheme.spacing(4),
      paddingLeft: typedTheme.spacing(2),
    },
    '.helper-list-icon': {
      ...labelStyles,
      paddingLeft: '0',
    },
  };
});
